var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.points)?_c('canvas',{directives:[{name:"render",rawName:"v-render",value:(_vm.points),expression:"points"}],attrs:{"width":_vm.width,"height":_vm.height}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }